import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../config';

const Beuty = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}api/cet/ब्यूटी व फैशन`);
        console.log('Response data:', response.data);
        setData(response.data.cetegorie || []);
      } catch (err) {
        console.error(err);
        setError('No Updates available at this moment.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const renderLoading = () => {
    const text = "Loading...";
    const rings = 2;
    const ringSectors = 30;

    return (
      <div className="preloader-container">
        <div className="preloader" id="preloader">
          {[...Array(rings)].map((_, ringIndex) => (
            <div key={ringIndex} className="preloader__ring">
              {[...Array(ringSectors)].map((_, sectorIndex) => (
                <div
                  key={sectorIndex}
                  className="preloader__sector"
                  style={{
                    transform: `rotateY(${(360 / ringSectors) * sectorIndex}deg) translateZ(7rem)`
                  }}
                >
                  {text[sectorIndex] || ''}
                </div>
              ))}
            </div>
          ))}
        </div>
        <style jsx>{`
          .preloader-container, .preloader {
            display: flex;
          }

          .preloader-container {
            background: #ebeef0;
            color: #015d72;
            font: 1em 'Dosis', sans-serif;
            height: 100vh;
            line-height: 1.5;
            perspective: 40em;
          }

          .preloader {
            animation: tiltSpin 8s linear infinite;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            margin: auto;
            width: 17em;
            height: 17em;
            transform-style: preserve-3d;
        margin-bottom:400px;
          }

          .preloader__ring {
            animation: spin 4s linear infinite;
            font-size: 2em;
            position: relative;
            height: 3rem;
            width: 1.5rem;
            transform-style: preserve-3d;
          }

          .preloader__ring:nth-child(even) {
            animation-direction: reverse;
          }

          .preloader__sector {
            font-weight: 600;
            position: absolute;
            top: 0;
            left: 0;
            text-align: center;
            text-transform: uppercase;
            transform: translateZ(7rem);
          }

          .preloader__sector, .preloader__sector:empty:before {
            display: inline-block;
            width: 100%;
            height: 100%;
          }

          .preloader__sector:empty:before {
            background: linear-gradient(transparent 45%, currentColor 45% 55%, transparent 55%);
            content: "";
          }

          @keyframes tiltSpin {
            from {
              transform: rotateY(0) rotateX(30deg);
            }
            to {
              transform: rotateY(1turn) rotateX(30deg);
            }
          }

          @keyframes spin {
            from {
              transform: rotateY(0);
            }
            to {
              transform: rotateY(1turn);
            }
          }
        `}</style>
      </div>
    );
  };

  if (loading) return renderLoading();

  if (error) return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'calc(100vh - 300px)',
      backgroundColor: 'white'
    }}>
      <div style={{ color: 'red', marginBottom: '1rem' }}>{error}</div>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '0.5rem 1rem',
          backgroundColor: '#3498db',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}
      >
        Retry
      </button>
    </div>
  );

  const renderMedia = (item) => {
    if (item.link) {
      return (
        <iframe
          src={item.link}
          title={item.cetegorieName}
          className="img-fluid w-100"
          style={{ objectFit: 'cover', height: '200px' }}
        />
      );
    } else if (item.image) {
      const imageUrl = `${API_URL}${item.image}`;
      return (
        <img
          src={imageUrl}
          alt={item.cetegorieName}
          className="img-fluid w-100"
          style={{ objectFit: 'cover', height: '200px' }}
        />
      );
    } else {
      return (
        <div
          className="img-fluid w-100 bg-secondary d-flex justify-content-center align-items-center"
          style={{ height: '200px' }}
        >
          No media available
        </div>
      );
    }
  };

  return (
    <div className="container-fluid mt-5 pt-3" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div id="ContentPlaceHolder1_divNoNews" className="no-news">
              <span id="lblNoNews"></span>
            </div>
            <div className="row">
              <div className="col-12">
                <div
                  className="section-title"
                  style={{
                    color: 'white',
                    backgroundColor: '#002147',
                    marginBottom: '20px',
                    padding: '10px'
                  }}
                >
                  <h4 className="section-title">
                    <span style={{ color: 'white' }}>ब्यूटी व फैशन</span>
                  </h4>
                </div>
              </div>

              {data.map((item) => (
                <div className="col-lg-4 col-md-6 mb-4" key={item.id}>
                  <div className="position-relative mb-3" style={{ height: '450px' }}>
                    {renderMedia(item)}
                    <div className="allcolor border border-top-0 p-4" style={{ height: '250px', overflow: 'hidden' }}>
                      <Link
                        to={`/${item.id}`}
                        className="alla h2 d-block mb-3 text-uppercase font-weight-bold"
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                      >
                        {item.short_description}
                      </Link>
                      <p className="allp m-0" style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
                        {item.description || 'No description available'}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Beuty;